import React, { useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const ToolTipIcon = React.forwardRef(({...props},ref) => {
  
  const iconRef = useRef();
  const [isHover,setIsHover] = useState(false);

  useImperativeHandle(ref, () => {
    const getBoundingClientRect = () =>{
      return iconRef?.current?.getBoundingClientRect();
    }
    return {
      getBoundingClientRect,
    }
  },[iconRef,props]);
  
  return(
    <svg style={{cursor: props.canShowTooltipContent ? "pointer" : "default"}} ref={iconRef} className='polymer-textlabel__label-container-tooltip-icon' onMouseEnter={()=>{
      props.setTooltipShow(true);
      setIsHover(true);
    }} onMouseLeave={()=>{
      props.setTooltipShow(false);
      setIsHover(false);
    }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_479_93106)">
        <path d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="white" stroke={props.canShowTooltipContent ? (isHover ? "#085054" : "#323232") : "#323232"} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.0098 16L12.0098 12" stroke={props.canShowTooltipContent ? (isHover ? "#085054" : "#0C8188") : "#0C8188"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="12" cy="8" r="1" fill={props.canShowTooltipContent ? (isHover ? "#085054" : "#0C8188") : "#0C8188"}/>
      </g>
      <defs>
        <clipPath id="clip0_479_93106">
        <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
});

function P2TextLabel(props) {

  const [tooltipShow, setTooltipShow] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({x:0,y:0});

  const tooltipRef = useRef(null);
  const tooltipSpanRef = useRef(null);
  const tooltipContainerRef = useRef(null);

  useEffect(()=>{
    if(props.canShowTooltipContent && tooltipShow && tooltipRef.current && tooltipContainerRef.current && tooltipSpanRef.current){
      let x = tooltipRef.current?.getBoundingClientRect().left - (tooltipContainerRef.current.offsetWidth/2) + (tooltipRef.current?.getBoundingClientRect().width/2);
      let y = tooltipRef.current?.getBoundingClientRect().height + tooltipSpanRef.current?.offsetTop + 10; //10 buffer
      setTooltipPosition({...tooltipPosition,x:x < 0 ? 0 : x,y:y});
    }
  },[tooltipShow, tooltipRef, tooltipContainerRef, tooltipSpanRef])

  const IconComponent = useMemo(()=>{
    return <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip><div className='polymer-textlabel__tooltip'>
      {typeof props.tooltipContent == "string" && <p style={{margin: 0}}>{props.tooltipContent}</p>}
      {typeof props.tooltipContent == "object" && props.tooltipContent}
    </div></Tooltip>}
    show={props.canShowTooltipContent && tooltipShow}
  >
    {({ ref, ...triggerHandler }) => (
      
      <span ref={ref}><span {...triggerHandler} ref={tooltipSpanRef}><ToolTipIcon canShowTooltipContent={props.canShowTooltipContent} setTooltipShow={setTooltipShow} ref={tooltipRef}/> </span></span>
    )}
  </OverlayTrigger>

  },[props.canShowTooltipContent, props.tooltipContent, tooltipShow])

  return (
    <>
  
    <div className='polymer-textlabel__label-container'>
      <div className='polymer-textlabel__label-container-label' style={{marginBottom: props.marginBottom}}>
        <label for={props.for} className='m-0' style={{color: props.color, fontWeight:props.bold, fontSize: props.fontSize, lineHeight: props.lineHeight}}>{props.tooltipPosition === "start" && props.hasTooltip && IconComponent}{props.label} {props.required && <span className='m-0 required'>*</span>} {props.tooltipPosition === "end" && props.hasTooltip && IconComponent}</label>
      </div>
    </div>
    {/* {props.canShowTooltipContent && tooltipShow && <div style={{zIndex:999, position:"absolute", left:tooltipPosition.x, top: tooltipPosition.y}}>
      <div ref={tooltipContainerRef} style={props.tooltipStyle}>
        <div style={{ maxWidth:400, padding:16}}>
          {typeof props.tooltipContent == "string" && <p style={{margin: 0}}>{props.tooltipContent}</p>}
          {typeof props.tooltipContent == "object" && props.tooltipContent}
        </div>
      </div>
    </div>} */}
  </>
  )
}

export default P2TextLabel

 {/* {props.hasTooltip && <div ref={tooltipRef} onMouseEnter={()=>{
        setTooltipShow(true);
      }} onMouseLeave={()=>{
        setTooltipShow(false);
      }} className='polymer-textlabel__label-container-tooltip-icon'>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_2850_96233)"><path d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z" fill="#F7F7F7" stroke="#575757" strokeLinecap="round" strokeLinejoin="round"/><path d="M12.0098 16L12.0098 12" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12.0098 8L11.9998 8" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_2850_96233"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
      </div>} */}

P2TextLabel.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  required: PropTypes.bool,
  hasTooltip: PropTypes.bool,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  tooltipPosition : PropTypes.oneOf(['start', 'end']),
  tooltipStyle: PropTypes.any,
  color: PropTypes.string,
  bold: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginBottom: PropTypes.string,
  fontSize: PropTypes.string,
  lineHeight: PropTypes.string,
  canShowTooltipContent: PropTypes.bool,
  for: PropTypes.string,
}


P2TextLabel.defaultProps = {
  required: false,
  hasTooltip: false,
  bold: undefined,
  tooltipPosition: "end",
  fontSize: "1.125rem",
  lineHeight: "1.75rem",
  tooltipContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  tooltipStyle: {backgroundColor: "white", boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.15)"},
  canShowTooltipContent: true
};
